module.exports = __webpack_public_path__ + "static/media/FFlogo-hvit.dbc09d6b.svg";